module.exports = __webpack_public_path__ + "img/bubble-2.008bb98d.png";